/* eslint-disable */
import React from 'react';
import {motion} from 'framer-motion';
import {Box} from '@mui/material';
import {varWrapEnter} from "@/components/animate/variants";

const MotionContainer = ({open, children, ...other}: any): any => {
    return (
        <Box
            component={motion.div}
            initial={false}
            animate={open ? 'animate' : 'exit'}
            variants={varWrapEnter}
            {...other}
        >
            {children}
        </Box>
    );
}

export default MotionContainer
